function section_is_document(section = {}, form = {}) {
  const section_label = String(section?.label || '').trim().toLowerCase();
  const form_name = String(form?.form_name || '').trim().toLowerCase();
  const is_document = ['document', 'upload', 'attachment', 'file', 'evidence']
    .some((word) => section_label.includes(word) || form_name.includes(word));
  return is_document;
}

const SECTION_TONE_MATCHERS = [
  { tone: 'danger', words: ['document', 'upload', 'attachment', 'file', 'evidence'] },
  { tone: 'teal', words: ['bank', 'payment', 'salary', 'account'] },
  { tone: 'amber', words: ['employment', 'role', 'manager', 'job'] },
  { tone: 'navy', words: ['residential', 'address', 'location', 'city'] },
  { tone: 'success', words: ['emergency', 'contact', 'next of kin'] },
  { tone: 'teal', words: ['personal', 'profile', 'identity', 'bio'] }
];

const DOCUMENT_QUESTION_WORDS = ['document', 'upload', 'attachment', 'file', 'certificate', 'id copy', 'proof', 'bank statement'];
const MISSING_DOCUMENT_ANSWERS = ['not answered', 'not uploaded', 'pending'];

function find_section_tone(normalized_label = '') {
  const matched_tone = SECTION_TONE_MATCHERS.find(({ words }) => (
    words.some((word) => normalized_label.includes(word))
  ));
  const resolved_tone = matched_tone?.tone || 'navy';
  return resolved_tone;
}

function build_document_url(raw_answer = '', looks_like_url = false) {
  const needs_protocol = looks_like_url && !/^https?:\/\//i.test(raw_answer);
  const normalized_url = needs_protocol ? `https://${raw_answer}` : raw_answer;
  return normalized_url;
}

function is_uploaded_document(raw_answer = '') {
  const normalized_answer = raw_answer.toLowerCase();
  const uploaded = Boolean(raw_answer) && !MISSING_DOCUMENT_ANSWERS.includes(normalized_answer);
  return uploaded;
}

export function build_detail_tabs(case_form_sections = [], agreement_rows = []) {
  const document_section_tabs = [];
  const other_section_tabs = [];

  case_form_sections.forEach((form, form_index) => {
    form.sections.forEach((section, section_index) => {
      const tab = {
        id: `section-${form_index}-${section_index}-${section.id}`,
        label: section.label,
        icon: 'bi-list-check',
        form_name: form.form_name,
        section
      };

      if (section_is_document(section, form)) {
        tab.icon = 'bi-folder';
        document_section_tabs.push(tab);
        return;
      }

      other_section_tabs.push(tab);
    });
  });

  return [
    { id: 'summary', label: 'Summary', icon: 'bi-grid' },
    ...document_section_tabs,
    ...other_section_tabs,
    { id: 'agreements', label: 'Agreements', icon: 'bi-folder', count: agreement_rows.length ? String(agreement_rows.length) : '' }
  ];
}

export function section_tone(label = '') {
  const normalized_label = String(label || '').trim().toLowerCase();
  const tone = find_section_tone(normalized_label);
  return tone;
}

export function is_document_question(question = {}) {
  const label = String(question?.label || '').trim().toLowerCase();
  const answer = String(question?.answer || '').trim();
  const looks_like_url = /^(https?:\/\/|www\.)/i.test(answer);
  if (looks_like_url) return true;

  const is_document = DOCUMENT_QUESTION_WORDS.some((word) => label.includes(word));
  return is_document;
}

export function document_answer_meta(question = {}) {
  const raw_answer = String(question?.answer || '').trim();
  const looks_like_url = /^(https?:\/\/|www\.)/i.test(raw_answer);
  const normalized_url = build_document_url(raw_answer, looks_like_url);
  const uploaded = is_uploaded_document(raw_answer);
  const document_meta = {
    name: raw_answer || 'Not uploaded',
    url: looks_like_url ? normalized_url : '',
    uploaded
  };

  return document_meta;
}
